import styled from 'styled-components';
export const StickyWrap = styled.div `
  .sticky-inner-wrapper {
    z-index: 9999;
  }
`;
//# sourceMappingURL=styled.js.map